import React, { useEffect, useMemo, useState } from "react";
import { PageTitle } from "components/common/Text";
import { SOFTWARE_VERSIONS_GRID_COLUMNS } from "./versions.config";
import { deviceTypes, getSystemInfo, SoftwareVersionTypes } from "./versions.api";
import { showError } from "utils/notifications";
import { getSortList } from "utils/util-functions";
import style from "./versions.module.css";
import VersionTable from "./components/version-table.component";
import { Popup } from "components/common/popup/popup.component";
import { Spinner } from "components/common/spinner/spinner.component";

export default function VersionsPage(): JSX.Element {
  const [megaFi1Data, setMegaFi1Data] = useState<SoftwareVersionTypes[]>([]);
  const [megaFi2Data, setMegaFi2Data] = useState<SoftwareVersionTypes[]>([]);
  const [aw12Data, setAW12Data] = useState<SoftwareVersionTypes[]>([]);
  const [sortOrder, setSortOrder] = useState<string>("");
  const [sortBy, setSortBy] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getInfo = async () => {
    setIsLoading(true);
    try {
      const mega1Response = await getSystemInfo(deviceTypes.megaFi1);
      const mega2Response = await getSystemInfo(deviceTypes.megaFi2);
      const aw12Response = await getSystemInfo(deviceTypes.aw12);

      setMegaFi1Data(mega1Response);
      setMegaFi2Data(mega2Response);
      setAW12Data(aw12Response);
      setIsLoading(false);
    } catch (error: any) {
      console.warn("error", error);
      showError(error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  const handleRequestSort = (order: string, orderBy: string) => {
    setSortOrder(order);
    setSortBy(orderBy);
  };

  const sortedMega1List: SoftwareVersionTypes[] = useMemo(() => {
    const sortColumn = SOFTWARE_VERSIONS_GRID_COLUMNS.find(({ id }) => id === sortBy);
    return getSortList(megaFi1Data, sortBy, sortOrder, sortColumn?.type);
  }, [sortOrder, sortBy, megaFi1Data]);

  const sortedMega2List: SoftwareVersionTypes[] = useMemo(() => {
    const sortColumn = SOFTWARE_VERSIONS_GRID_COLUMNS.find(({ id }) => id === sortBy);
    return getSortList(megaFi2Data, sortBy, sortOrder, sortColumn?.type);
  }, [sortOrder, sortBy, megaFi2Data]);

  const sortedAW12List: SoftwareVersionTypes[] = useMemo(() => {
    const sortColumn = SOFTWARE_VERSIONS_GRID_COLUMNS.find(({ id }) => id === sortBy);
    return getSortList(aw12Data, sortBy, sortOrder, sortColumn?.type);
  }, [sortOrder, sortBy, aw12Data]);

  return (
    <>
      <PageTitle>Software Versions</PageTitle>
      <div className={style.contentContainer}>
        <div style={{ paddingRight: "32px" }}>
          <VersionTable
            title="MegaFi-2"
            handleRequestSort={handleRequestSort}
            data={megaFi2Data}
            dataList={sortedMega2List}
          />
        </div>

        <div style={{ paddingRight: "32px" }}>
          <VersionTable
            title="MegaFi-1"
            handleRequestSort={handleRequestSort}
            data={megaFi1Data}
            dataList={sortedMega1List}
          />
        </div>

        <VersionTable title="AW-12" handleRequestSort={handleRequestSort} data={aw12Data} dataList={sortedAW12List} />
      </div>

      <Popup title="Loading data..." open={isLoading}>
        <Spinner />
      </Popup>
    </>
  );
}
